import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const DaysSelector = ({ name, value, onChange, classes }) => {
  const toggleDay = (day) => {
    const isSelected = value.includes(day);
    const updatedDays = isSelected ? value.filter((d) => d !== day) : [...value, day];
    onChange(name, updatedDays);
  };

  // filter invalid values
  useEffect(() => {
    if (!value.length > 0) return;

    const cleanedValues = [];
    let hasInvalid = false;

    for (let i = 0; i < value.length; i++) {
      if (WEEK_DAYS_LOOKUP[value[i]]) {
        cleanedValues.push(value[i]);
      } else {
        hasInvalid = true;
      }
    }

    if (hasInvalid) {
      onChange(name, cleanedValues);
    }
  }, []);

  return (
    <div className={`d-flex gap-2 user-select-none ${classes ?? ''}`}>
      {weekDaysOptionsList.map((day) => {
        const isSelected = value.includes(day.value);

        return (
          <div
            key={day.value}
            onClick={() => toggleDay(day.value)}
            className={`theme-width-40 theme-height-40 d-flex justify-content-center align-items-center theme-font-inter-semi-bold border-grey-13-h-1 rounded-circle cursor-pointer ${
              isSelected ? 'theme-background-green-1 theme-text-white-1' : 'theme-text-grey-1'
            }`}
          >
            {day.displayValue}
          </div>
        );
      })}
    </div>
  );
};

DaysSelector.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
};

export default DaysSelector;

const weekDaysOptionsList = [
  { displayValue: 'S', value: 'sunday' },
  { displayValue: 'M', value: 'monday' },
  { displayValue: 'T', value: 'tuesday' },
  { displayValue: 'W', value: 'wednesday' },
  { displayValue: 'T', value: 'thursday' },
  { displayValue: 'F', value: 'friday' },
  { displayValue: 'S', value: 'saturday' },
];

const WEEK_DAYS_LOOKUP = {
  sunday: 'S',
  monday: 'M',
  tuesday: 'T',
  wednesday: 'W',
  thursday: 'T',
  friday: 'F',
  saturday: 'S',
};
